import * as React from 'react';
import { SVGProps } from 'react';

const IconCalendarSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 1.5a1 1 0 0 0-1 1V4H3a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-3V2.5a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1V4H9V2.5a1 1 0 0 0-1-1H7zm-2.857 8.59h15.714v7.82H4.143v-7.82z"
    />
  </svg>
);
export default IconCalendarSizeM;
